document.addEventListener("DOMContentLoaded", function () {
  const form = document.getElementById("BackInStockForm");
  if (!form) return;

  const successMsg = document.getElementById("BackInStockSuccess");
  const errorMsg = document.getElementById("BackInStockError");

  const submitButton = form.querySelector(".back-in-stock-notify-button");
  const buttonText = submitButton.querySelector(".back-in-stock-notify-button-text");
  const loadingOverlay = submitButton.querySelector(".loading-overlay");

  const inputProductTitle = document.getElementById("BackInStockProductTitle");
  const inputProductHandle = document.getElementById("BackInStockProductHandle");
  const inputVariantId = document.getElementById("BackInStockVariantId");
  const inputVariantTitle = document.getElementById("BackInStockVariantTitle");
  const inputVariantSKU = document.getElementById("BackInStockVariantSKU");

  const productTitle = inputProductTitle?.value || "";
  const productHandle = inputProductHandle?.value || "";

  const variantsJSON = JSON.parse(
    document.getElementById("ProductVariantsJSON")?.textContent || "[]"
  );
  const variantIdInput = document.querySelector(".product-variant-id");

  function updateVariantInfo() {
    const variantId = parseInt(variantIdInput?.value);
    inputVariantId.value = variantId;

    const found = variantsJSON.find((v) => v.id === variantId);
    inputVariantTitle.value = found ? found.title : "";
    inputVariantSKU.value = found ? found.sku : "";
  }

  inputProductTitle.value = productTitle;
  inputProductHandle.value = productHandle;
  updateVariantInfo();

  const observer = new MutationObserver(updateVariantInfo);
  if (variantIdInput) {
    observer.observe(variantIdInput, {
      attributes: true,
      attributeFilter: ["value"],
    });
  }

  form.addEventListener("submit", function (e) {
    e.preventDefault();

    successMsg.style.display = "none";
    errorMsg.style.display = "none";

    loadingOverlay.classList.remove("hidden");
    if (buttonText) buttonText.style.opacity = "0";
    submitButton.disabled = true;

    const data = new FormData(form);

    fetch(
      "https://script.google.com/macros/s/AKfycbwNHnA8jo4MGFOmJQK3skKTjjGpO8TGsHWHJsVjJDoVU9bIUsD7fXTfM13DIqJq32fCqA/exec",
      {
        method: "POST",
        body: data,
      }
    )
      .then((res) => res.text())
      .then((resText) => {
        const response = resText.trim().toLowerCase();

        if (response === "success") {
          form.reset();
          successMsg.style.display = "block";
        } else if (response === "duplicate") {
          errorMsg.style.display = "block";
        } else {
          alert("Unexpected error occurred.");
        }
      })
      .catch(() => {
        alert("Network error. Please try again.");
      })
      .finally(() => {
        loadingOverlay.classList.add("hidden");
        if (buttonText) buttonText.style.opacity = "1";
        submitButton.disabled = false;
      });
  });

  document.body.addEventListener("modalClosed", function () {
    if (successMsg) successMsg.style.display = "none";
    if (errorMsg) errorMsg.style.display = "none";
    if (form) form.reset();
  });
});